export const ROUTING_MODES = {
  NONE: "none",
  ROUND_ROBIN_GROUP: "round_robin_group",
  ROUND_ROBIN_TEAM: "round_robin_team",
};

export const ROUTING_OPTIONS = [
  {
    key: ROUTING_MODES.NONE,
    title: "No Auto-Assignment (Default)",
    description: "Tickets remain unassigned until manually assigned by an agent or admin.",
    minHeight: 80,
    minHeightSelected: 80,
  },
  {
    key: ROUTING_MODES.ROUND_ROBIN_GROUP,
    title: "Round Robin - All Available Agents",
    description:
      "Automatically assign to available agents in the selected group using round-robin distribution.",
    minHeight: 104,
    minHeightSelected: 104,
  },
  {
    key: ROUTING_MODES.ROUND_ROBIN_TEAM,
    title: "Round Robin - Specific Team",
    description:
      "Automatically assign to available agents in a specified team using round-robin distribution.",
    minHeight: 104,
    minHeightSelected: 160,
    showTeamSelect: true,
  },
];

export const IMPORTANT_NOTES = [
  "Round-robin assignment only considers agents who are currently available (online status)",
  "If no agents are available, tickets remain unassigned until an agent becomes available",
  "Agents can manually reassign tickets regardless of the routing settings",
  "Routing rules apply only to new incoming tickets, not existing ones",
];

export function formatGroupLabel(group) {
  if (!group) return "";
  const email =
    group.raw?.group_email ||
    group.raw?.email ||
    group.raw?.support_email ||
    group.raw?.channels?.[0]?.channel_id ||
    "";
  return email ? `${group.name} - ${email}` : group.name;
}

export function mapRoutingFromApi(ticketRouting) {
  return {
    mode: ticketRouting?.mode || ROUTING_MODES.NONE,
    teamId: ticketRouting?.team_id || "",
  };
}

export function buildRoutingPayload(mode, teamId) {
  if (mode === ROUTING_MODES.ROUND_ROBIN_TEAM) {
    return { mode, team_id: teamId };
  }
  return { mode };
}

export function getErrorMessage(error) {
  if (!error) return "Something went wrong.";
  if (typeof error === "string") return error;
  return error.message || error.error || "Something went wrong.";
}
